module.exports = __webpack_public_path__ + "img/tel_submit.9706c871.png";